/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {trackEvent} from '../../helpers/listeners/analytics';
import {filterResource, filterUrl, stripTags} from "../../helpers/filters";
import './SplitCtaHero.scss';
import {trackEventByUrl} from "../../helpers/events";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";

interface Data {
    paragraphById: {
        fieldObjectImgMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
        fieldTxtSubTitle: string;
        fieldTxtHeadline: string;
        fieldVarVideoLink: Array<{
            title: string;
            uri: string;
        }>;
    }
}

class SplitCtaHeroQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
    query paragraphRevisionById($id: String!) {
        paragraphById:paragraphRevisionById(id: $id) {
            ... on Paragraph {
                ... on Paragraph {
                    ... on ParagraphComponentSplitCtaHero {
                        fieldVarVideoLink {
                            ... on FieldParagraphFieldVarVideoLink {
                                title
                                url {
                                    path
                                    routed
                                }
                            }
                        }
                        fieldTxtHeadline
                        fieldTxtSubTitle
                        fieldObjectImgMedia {
                            ... on FieldParagraphFieldObjectImgMedia {
                                entity {
                                    ... on MediaImage {
                                        fieldMediaImage {
                                            width
                                            height
                                            url
                                            alt
                                            title
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

class SplitCtaHero extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        componentIndex: PropTypes.number,
        markComponentLoadedAs: PropTypes.func.isRequired,
        handleLoadedComponents: PropTypes.func.isRequired
    };

    static defaultProps = {
        componentIndex: null
    };

    state = {
        modalOpen: false
    };

    openModal = (field, videoId, event) => {
        if (videoId) {
            event.preventDefault();
            event.stopPropagation();
            if (field && field.fieldTxtHeadline) {
                trackEvent('Video', 'Play', `${stripTags(field.fieldTxtHeadline)} - ${videoId.type}:${videoId.id}`);
            } else {
                trackEvent('Video', 'Play', `${document.title.split('|')[0].trim()} - ${videoId.type}:${videoId.id}`);
            }

            this.setState({modalOpen: true});
            return false;
        }

        return true;
    };

    render() {
        // eslint-disable-next-line no-unused-vars
        const {id, componentIndex, markComponentLoadedAs, handleLoadedComponents} = this.props;

        return (
            <SplitCtaHeroQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;

                    const isFirstComponent = componentIndex === 0;
                    const videoId = field.fieldVarVideoLink && field.fieldVarVideoLink.url && field.fieldVarVideoLink.url.path ? ReactVideoModal.getVideoId(field.fieldVarVideoLink.url.path) : null;

                    // Set H1 or H2 according to component order
                    let headline = field.fieldTxtHeadline ? (
                        <h2 className="splitCtaHero__title">{field.fieldTxtHeadline}</h2>
                    ) : null;
                    let ctaHeadline = field.fieldTxtSubTitle ? (
                        <h3 className="splitCtaHero__subtitle">{field.fieldTxtSubTitle}</h3>
                    ) : null ;

                    if (isFirstComponent) {
                        headline = field.fieldTxtHeadline ? (
                            <h1 className="splitCtaHero__title">{field.fieldTxtHeadline}</h1>
                        ) : null;
                        ctaHeadline = field.fieldTxtSubTitle ? (
                            <h2 className="splitCtaHero__subtitle">{field.fieldTxtSubTitle}</h2>
                        ) : null;

                    }

                    // Get Background Image
                    let backgroundImage = '';
                    if (field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url) {
                        backgroundImage = filterResource(field.fieldObjectImgMedia.entity.fieldMediaImage.url);
                    }

                    markComponentLoadedAs(id, true);

                    return (
                        <div className="splitCtaHero">

                            <div className="splitCtaHero__inner">
                                {backgroundImage && (
                                    <div className="splitCtaHero__background">
                                        <img src={backgroundImage} alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                    </div>
                                )}


                                {videoId && (
                                    <ReactVideoModal uri={field.fieldVarVideoLink.url.path}
                                                     inline={false}
                                                     eventButtonTitle={field.fieldVarVideoLink && field.fieldVarVideoLink.title ? field.fieldVarVideoLink.title : 'Watch Video'}
                                                     isOpen={this.state.modalOpen}
                                                     onClose={() => this.setState({modalOpen: false})} />
                                )}

                                <div className="container splitCtaHero__wrapper">

                                    <div className="splitCtaHero__column splitCtaHero__column--main">
                                        {headline}
                                    </div>

                                    <div className="splitCtaHero__column splitCtaHero__column--secondary">
                                        <div className="splitCtaHero__cta--desktop">
                                            {ctaHeadline}

                                            {videoId && field.fieldVarVideoLink && field.fieldVarVideoLink.url && (
                                                <button className="videoButton splitCtaHero__link button button--white"
                                                   onClick={(e) => {
                                                       trackEventByUrl(field.fieldVarVideoLink.url.path, field.fieldVarVideoLink.title);
                                                       this.openModal(field, videoId, e);
                                                   }}>
                                                    {field.fieldVarVideoLink.title}
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="container splitCtaHero__mobileCta">
                                <div className="splitCtaHero__cta--mobile">
                                    {ctaHeadline}

                                    {videoId && field.fieldVarVideoLink && field.fieldVarVideoLink.url && (
                                        <a className="videoButton splitCtaHero__link button button--ghost"
                                           onClick={(e) => {
                                               trackEventByUrl(field.fieldVarVideoLink.url.path, field.fieldVarVideoLink.title);
                                               this.openModal(field, videoId, e);
                                           }}>
                                            {field.fieldVarVideoLink.title}
                                        </a>
                                    )}
                                </div>
                            </div>

                        </div>
                    );
                }}
            </SplitCtaHeroQuery>
        )
    }

}


export default SplitCtaHero;



// WEBPACK FOOTER //
// ./frontend/components/SplitCtaHero/SplitCtaHero.jsx